import { Component } from '@angular/core';
import { ContentService } from '../../services/content.service';
import { ConfigService } from '../../services/configuration.service';
import { BrandService } from '../../services/brand.service';
import { AssetConfigVariableService } from '../../services/asset-config-variable.service';

@Component({
  selector: 'fraud-prevention',
  templateUrl: './fraud-prevention.page.html',
})
export class FraudPreventionPage {
  public scamsExamples;
  public verticalBannerDesktop;
  public verticalBannerMobile;
  public description: string;
  public isMobileView: boolean;
  public brand: string = this.brandService.getBrand();
  public imageRootPath: string = '';
  constructor(
    private contentService: ContentService,
    private brandService: BrandService,
    private assetConfigVariableService: AssetConfigVariableService,
    configService: ConfigService
  ) {
    this.isMobileView = configService.Get('mobileView');
    this.loadContent();
  }

  async ngOnInit() {
    this.imageRootPath =
      await this.assetConfigVariableService.getImageRootPath();
  }

  private loadContent(): void {
    this.contentService.getData().then((result) => {
      if (!result || !result.fraudPrevention) {
        return;
      }

      this.scamsExamples = result.fraudPrevention.accordions;
      this.description = result.fraudPrevention.description;
      this.verticalBannerDesktop = result.fraudPrevention.verticalBannerDesktop;
      this.verticalBannerMobile = result.fraudPrevention.verticalBannerMobile;
    });
  }
}
